module.exports = __webpack_public_path__ + "static/media/coconutflake.b9b0206f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/coconutflake.jpg
// module id = 124
// module chunks = 0